/* eslint-disable */
import { Component } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import m from '@utils/strings';

class AreaResultadoError extends Component {
    render() {
        
        let { msgErrorApi } = this.props;

        return (
            <Grid columns='equal' style={{ marginRight: 365, marginTop: 50, marginLeft: 35 }}>
                <Grid.Column key='1'>
                    <div className={"div-area-resultado-autorizacao-ps"}>
                        <div>
                            <label id={"label-erro-servico"}>
                                {m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_API_ERROR}
                            </label>
                        </div>
                        <div>
                            <label id={"label-erro-servico-subtitulo"}>
                                {
                                    (msgErrorApi ?? []).length > 0
                                        ? msgErrorApi
                                        : m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_API_ERROR_SUBTITULO
                                }
                            </label>
                        </div>
                        <div className={"div-separador-top-bottom-25"}>
                            <hr className={"hr-class"} style={{ marginRight: 99 }} />
                        </div>
                        <div className={"div-separador-top-10"}>
                            <Button
                                onClick={() => {
                                    this.props.resetAllStates();
                                }}
                                className={"btn-default-cemig"}>
                                {m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_NOVO_ATENDIMENTO} (ENTER)
                                </Button>
                        </div>
                    </div>
                </Grid.Column>
            </Grid>
        )
    }
}

export default AreaResultadoError;
